var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "main-text",
    style: _vm.heightStyle
  }, [_c('div', {
    ref: "feedText",
    staticClass: "text-dv",
    class: {
      'text-dv-push': _vm.isPush,
      'panel-text-dv': _vm.panelStyle
    },
    attrs: {
      "id": 'commentText' + _vm.dataIndex
    },
    domProps: {
      "innerHTML": _vm._s(_vm.text)
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.contentClick.apply(null, arguments);
      }
    }
  }), _vm.poiLink && _vm.author.date ? _c('div', {
    staticClass: "date"
  }, [_c('span', [_vm._v("发布于")]), _vm._v(_vm._s(_vm.author.date))]) : _vm._e(), _vm.showMore ? _c('open-more', {
    on: {
      "open-click": _vm.handleOpen
    }
  }) : _vm._e()], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };